import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Modal from 'containers/Modals/Modal';
import { Button, translate } from '@haldor/ui';
import './_SelectLinkedPosition.scss';

var SelectLinkedPosition = /*#__PURE__*/function (_Component) {
  _inherits(SelectLinkedPosition, _Component);

  var _super = _createSuper(SelectLinkedPosition);

  function SelectLinkedPosition(props) {
    var _this;

    _classCallCheck(this, SelectLinkedPosition);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onModalClose", function () {
      if (_this.props.onClose != null && typeof _this.props.onClose === 'function') {
        _this.props.onClose();
      }
    });

    return _this;
  }

  _createClass(SelectLinkedPosition, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          translate = _this$props.translate,
          lesson = _this$props.lesson;
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        onClose: this.onModalClose,
        overridePrompt: true,
        type: "linked-schedule-position"
      }, /*#__PURE__*/React.createElement("h2", null, translate('Select group')), /*#__PURE__*/React.createElement("div", {
        className: "select-lessons-container"
      }, lesson.linkedSchedulePositions.map(function (lesson) {
        var reported = lesson.attendanceReported != null;
        return /*#__PURE__*/React.createElement(Link, {
          to: "/lesson/".concat(lesson.id),
          className: "lesson-item",
          key: lesson.id
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, lesson.section.title), /*#__PURE__*/React.createElement("div", {
          className: "status"
        }, /*#__PURE__*/React.createElement("span", {
          className: "indicator",
          style: {
            backgroundColor: reported ? '#19DB6C' : '#dbdbdb'
          }
        }), reported ? translate('reported') : translate('not-reported-lesson')));
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          marginTop: '2rem',
          justifyContent: 'flex-end'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onModalClose
      }, translate('Cancel'))));
    }
  }]);

  return SelectLinkedPosition;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(SelectLinkedPosition);